import get from 'lodash/get'
import set from 'lodash/set'
import unset from 'lodash/unset'
import isEmpty from 'lodash/isEmpty'
import filter from 'lodash/filter'
import indexOf from 'lodash/indexOf'
import now from 'lodash/now'
import InstantApp from '../InstantApp'
import { createSettings } from './settings'
import { createCustomFields } from './customFields'
import * as integrationType from 'constants/integrationType'
import { getPathsByType } from '../../../utils/customFieldsUtils'
import * as customFieldTypes from 'constants/customFieldTypes'
import { ECOMMERCE } from 'constants/templateCategory'
import thumbnail from '../assets/img/thumbnail.jpg'
import { createShopifyWizardConf } from './shopifyWizardConf'
import generate from 'firebase-auto-ids'

const defaultSlides = 3

export const information = {
  id: 'outSide',
  title: '3D Cube',
  image: thumbnail,
  thumbnailPath: [ 'intro', 'image' ],
  category: ECOMMERCE,
  description: 'Showcase your products with seamless shopping and checkout.',
  integrations: [ integrationType.SHOPIFY ],
  instantApp: InstantApp,
  minSlides: 1,
  maxSlides: 8,
  defaultSlides: defaultSlides,
  defaultSettings: createSettings(defaultSlides), // Create default settings with 3 slides
  skipSlides: {
    videoScene: {
      name: 'Skip Video scene',
      path: ['door']
    },
    lastScene: {
      name: 'Skip Final scene',
      path: ['lastScene']
    }
  },
  canDisableRedirectOnSwipe: true
}

function createDeleteSlidePath (app, slidesCnt) {
  const res = []
  for (const i in app.customFields.showcases) {
    if (i >= slidesCnt) {
      res.push(`showcases/${i}`)
    }
  }
  return res
}

// these paths are used to find paths those should be deleted when a customer deletes product with the productId
export function pathsByProductId (app, productId) {
  const res = []
  const showcases = get(app, ['customFields', 'showcases'], {})

  for (const showcaseId in showcases) {
    const showcase = showcases[showcaseId]
    const products = get(showcase, 'products', {})
    for (const productNum in products) {
      const p = products[productNum]
      if (p.productId === productId) {
        res.push(['showcases', showcaseId, 'products', productNum])
      }
    }
  }
  return res
}

function applySkippedSlides (settings, skipSlidesIds) {
  for (const slideId of skipSlidesIds) {
    const sInfo = information.skipSlides[slideId]
    if (sInfo) unset(settings, sInfo.path)
  }
}

export function createDefaultCustomFields (slidesCnt = defaultSlides) {
  const settings = createSettings(slidesCnt)
  const cf = {
    showcases: []
  }
  for (let i = 0; i < slidesCnt; i++) {
    cf.showcases.push({
      slideId: generate(now())
    })
    const copyPaths = [
      ['showcases', i, 'products', 0, 'x'],
      ['showcases', i, 'products', 0, 'y'],
      ['showcases', i, 'products', 1, 'x'],
      ['showcases', i, 'products', 1, 'y']
    ]
    for (const path of copyPaths) {
      set(cf, path, get(settings, path))
    }
  }
  return cf
}

function addSlide (app) {
  const newSlideIndex = get(app, 'slidesCnt', defaultSlides)
  const newSlideId = generate(now())
  console.log('addSlide, newSlideIndex', newSlideIndex, 'newSlideId', newSlideId)
  set(app, ['customFields', 'showcases', newSlideIndex, 'slideId'], newSlideId)
  const newSlidesCnt = app.slidesCnt + 1
  const settings = createSettings(newSlidesCnt)
  const copyPaths = [
    ['showcases', newSlideIndex, 'products', 0, 'x'],
    ['showcases', newSlideIndex, 'products', 0, 'y'],
    ['showcases', newSlideIndex, 'products', 1, 'x'],
    ['showcases', newSlideIndex, 'products', 1, 'y']
  ]
  for (const path of copyPaths) {
    set(app.customFields, path, get(settings, path))
  }
}

function delSlide (app, slideNum) {
  const slideId = get(app, ['customFields', 'showcases', slideNum, 'slideId'])
  console.log('delSlide slideId', slideId)
  app.customFields.showcases.splice(slideNum, 1)
  const customStyles = [
    `ou_showcase_${slideId}_image_p`,
    `ou_static-logo-showcase-p${slideId}`,
    `ou_showcase_link_p${slideId}_0`,
    `ou_showcase_link_p${slideId}_1`
  ]
  for (const className of customStyles) {
    unset(app, ['customFields', 'customStyles', className])
  }
}


export function getTemplate (app, testGroup) {
  const slidesCnt = get(app, 'slidesCnt', defaultSlides)
  const skipSlidesIds = get(app, 'customFields.appSettings.skipSlides', [])
  let customFields = createCustomFields(slidesCnt)
  if (!isEmpty(skipSlidesIds)) customFields = filter(customFields, scene => indexOf(skipSlidesIds, scene.id) < 0)
  const settings = {...createSettings(slidesCnt)}
  applySkippedSlides(settings, skipSlidesIds)
  const shopifyWizardConf = createShopifyWizardConf(slidesCnt, testGroup)
  return {
    id: 'outSide',
    customFields,
    settings,
    createDeleteSlidePath: createDeleteSlidePath,
    imagePaths: getPathsByType(customFields, customFieldTypes.IMAGE),
    videoPaths: getPathsByType(customFields, customFieldTypes.VIDEO),
    pathsByProductId: pathsByProductId,
    shopifyWizardConf,
    addSlide: addSlide,
    delSlide: delSlide
  }
}



// WEBPACK FOOTER //
// ./src/templates/outSide/template/index.js